import { Divider, Group } from '@byecode/ui'
import type { NodeTypes, WebsocketTriggerConfig } from '@lighthouse/shared'
import React, { useMemo } from 'react'

import OutputVariable from '@/containers/FlowDetail/components/OutputVariable'

import { VariableListControlled } from '../../Common/VariableConfigure/VariableListControlled'
import * as SC from '../../styles'
import { TriggerModeDataSource } from '../components/TriggerModeDataSource'

interface WebsocketTriggerConfigureProps {
    nodeType: NodeTypes
    onNodeTypeChange: (val: NodeTypes) => void
    onNodeNameChange: (name: string) => void
    value: WebsocketTriggerConfig
    onChange: (value: WebsocketTriggerConfig) => void
}

export const WebsocketTriggerConfigure: React.FC<WebsocketTriggerConfigureProps> = ({
    nodeType,
    onNodeTypeChange,
    onNodeNameChange,
    value,
    onChange
}) => {
    const outputOptions = useMemo(
        () =>
            value?.args?.map(item => ({
                id: item.id,
                label: item.name,
                desc: '传入流程的参数',
                type: item.innerType
            })),
        [value?.args]
    )

    return (
        <SC.Container>
            <TriggerModeDataSource
                nodeType={nodeType}
                onNodeTypeChange={onNodeTypeChange}
                onNodeNameChange={onNodeNameChange}
                value={value}
                onChange={next => onChange(next as WebsocketTriggerConfig)}
            />

            <Divider />

            <Group label="传入流程的参数">
                <VariableListControlled value={value.args} hasValuePath onChange={args => onChange({ ...value, args })} />
            </Group>

            <OutputVariable options={outputOptions} />
        </SC.Container>
    )
}
